import { render } from "./ComExpand.vue?vue&type=template&id=cd9852a4&ts=true"
import script from "./ComExpand.vue?vue&type=script&lang=ts"
export * from "./ComExpand.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__